import styled from "styled-components";

export const Title = styled.h2`
   font-size: 36px;
   font-weight: 700;
   line-height: 50px;
   text-align: center;
   color: #2A2637;
   margin-bottom: 48px;
   margin-top: 2px;
   @media(max-width: 600px) {
     text-align: left;
     width: 200px;
     line-height: 33px;
     margin-bottom: 32px;
     margin-top: 20px;
   }   
   @media(max-width: 768px) {
     margin-top: 20px;
   }   
`

export const TitleText = styled.div`
  font-size: 28px;
  font-weight: 700;
  line-height: 39px;
  color: #2A2637;   
  margin-bottom: 16px;
  @media(max-width: 768px) {
     display: none;
`

export const TitleTextMobile = styled.div`
  display: none;
  @media(max-width: 768px) {
  display: block;
     font-weight: 700;
     line-height: 39px;
     color: #2A2637;   
     margin-bottom: 16px;
     font-size: 20px;
     margin-top: -50px;
  }  
`

export const Container = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   margin-bottom: 52px;
   @media(max-width: 600px) {
     align-items: flex-start ;
   }
   @media(max-width: 1100px) {
     padding: 0 15px;
   }   
`

export const Line = styled.div`
   width: 8px;
   height: 257px;
   border-radius: 20px;
   background-color: #CFEFF8;
   margin-right: 28px;
   @media(max-width: 768px) {
     height: 202px;
   }
`

export const Line2 = styled.div`
   width: 8px;
   height: 257px;
   border-radius: 20px;
   background-color: #B3EEE2;
   margin-right: 28px;
   @media(max-width: 768px) {
     height: 202px;
   }
`

export const Line3 = styled.div`
   width: 8px;
   height: 257px;
   border-radius: 20px;
   background-color: #C8E1E8;
   margin-right: 28px;
   @media(max-width: 768px) {
     height: 202px;
   }
`

export const TitleBlock = styled.div`
   font-size: 20px;
   font-weight: 700;
   line-height: 28px;
   color: #2A2637;
   margin-bottom: 16px;
   margin-top: 20px;
   @media(max-width: 768px) {
     font-size: 20px;
   }
`

export const Text = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  color: #4E4963;
  @media(max-width: 768px) {
     font-size: 14px;
     line-height: 22.4px;
  }
`

export const Block = styled.div`
  display: flex;
  @media(max-width: 1100px) {
     margin-bottom: 47px;
  }
`

export const BlockContent = styled.div`
  width: 288px;
  height: 257px;
  @media(max-width: 600px) {
     width: 276px;
  }
`

export const Btn = styled.div`
  margin-top: 12px;
`

export const Button = styled.div`
  margin-top: 16px;
`

export const WrapperBlock = styled.div`
   display: flex;
   justify-content: space-between;
   flex-wrap: wrap;
   width: 1100px;
   margin-bottom: 80px;
   @media(max-width: 1100px) {
     width: 100%;
     align-items: flex-start;
     margin-bottom: 0;
   }
`

export const WrapperBlockRating = styled.div`
   display: flex;
   justify-content: space-between;
   flex-wrap: wrap-reverse;
   width: 1100px;
   margin-bottom: 80px;
   @media(max-width: 1100px) {
     width: 100%;
     align-items: flex-start;
     margin-bottom: 0;
   }
`

export const WrapperText = styled.div`
  width: 463px;
`

export const Image = styled.img`
  width: 556px;
  height: 330px;
  @media(max-width: 768px) {
    margin-bottom: 16px;
  }
  @media(max-width: 600px) {
    width: 312px;
    height: 185px;
  }
`


